import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const UnitLabel = styled(Box)<{ clickable?: boolean }>`
  ${({ theme, clickable }) => css`
    font-weight: 600;
    color: ${theme.colors.secondary};
    white-space: normal;

    ${clickable &&
    css`
      cursor: pointer;
      color: ${theme.colors.primary};
      text-decoration: underline;
    `}
  `}
`

export const HeaderLabel = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-weight: 700;
`

export const IconWrapper = styled(Box)<{ color: string }>`
  ${({ color }) => css`
    display: flex;
    align-items: center;
    color: ${color};

    svg {
      width: 15px !important;
      height: 15px !important;
    }
  `}
`

export const CellWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  white-space: normal;
`

export const CellValue = styled(Box)`
  font-size: 14px;
`

export const CellTrend = styled(Box)`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #2a295c;
`

export const GrossMarginValue = styled(Box)`
  ${({ theme }) => css`
    font-size: 15px;
    font-weight: 700;
    text-align: center;
    color: ${theme.colors.secondary};
  `}
`
